import { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorCode } from './Error';
import { mapError } from './mapError';
import { ValidationResult } from './ValidationResult';

const RequiresReferenceSettingsErrorCode = 'slovak-max-price-export-requires-reference-settings';

export class ErrorResponse extends ApiClientErrorResponse {
	handleCalculationRequiresAtMostOneProductForEachCountry(): boolean {
		return this.handle(ErrorCode.OnlyOneProductPerCountryErrorCode);
	}

	handleCalculationRequiresAtLeastOneProduct(): boolean {
		return this.handle('slovak-max-price-calculation-requires-at-least-one-product');
	}

	handleCalculationRequiresAtLeastOneNonSkProduct(): boolean {
		return this.handle('slovak-max-price-calculation-requires-at-least-one-non-sk-product');
	}

	handleProductGroupNotFound(): boolean {
		return this.handle('product-group-not-found');
	}

	handleExportRequiresReferenceSettings(): boolean {
		return this.handle(ErrorCode.RequiresReferenceSettings);
	}

	handleCalculationRequiredProductSettingsIsMissing(): boolean {
		return this.handle(ErrorCode.RequiredProductSettingsMissingErrorCode);
	}

	handleProductGroupLocked(): boolean {
		return this.handle('product-group-locked');
	}

	handleCannotChangeSettingsForNonMemberProducts(): boolean {
		return this.handle('slovak-max-price-calculation-cannot-change-settings-for-non-member-products');
	}

	handleIllegalPriceTypeSelected(): boolean {
		return this.handle(ErrorCode.IllegalPriceTypeSelectedErrorCode);
	}

	handleCalculationRequiresAtLeastOneProductList(): boolean {
		return this.handle('slovak-max-price-calculation-requires-at-least-one-product-list');
	}

	handleLpCnRefExportContainsSlovakPzluProduct(): boolean {
		return this.handle('slovak-max-price-pzlu-product-for-cnref-lp-export');
	}

	handlePzluCnRefExportContainsSlovakLpProduct(): boolean {
		return this.handle('slovak-max-price-lp-product-for-cnref-pzlu-export');
	}

	handleAtLeastOneReferenceCountryProduct(): boolean {
		return this.handle(ErrorCode.AtLeastOneReferenceCountryProduct);
	}

	toValidationResult(): ValidationResult {
		const errors = this.errors.map(mapError);

		return new ValidationResult(
			errors.find((error) => error.productGroupId !== null)?.productGroupId ?? null,
			errors.find((error) => error.code === ErrorCode.RequiredProductSettingsMissingErrorCode) !== undefined,
			errors.filter((error) => error.productId !== null),
			errors.filter((error) => error.duplicateCountries.length > 0)
		);
	}
}
